import { render, staticRenderFns } from "./igt-button-field.vue?vue&type=template&id=67107b8a&scoped=true&"
import script from "./igt-button-field.vue?vue&type=script&lang=js&"
export * from "./igt-button-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67107b8a",
  null
  
)

export default component.exports